import Vuex from 'vuex'
import { createStore } from 'vuex-extensions';
// import 'es6-promise/auto';
import layout from './modules/layout';
import menu from './modules/menu';
import statistic from './modules/statistic';
// import report from './modules/report';
// import { authentication } from './modules/authentication';
// import { users } from './modules/users';

export default createStore(Vuex.Store, {
  state:{langIcon: '',langLangauge: '',isActive:false},
  getters:{
    langIcon: (state)=>{ return state.langIcon },
    langLangauge:(state)=>{ return state.langLangauge }
  },
  mutations: {
    changeLang (state, payload) {
      localStorage.setItem('currentLanguage', payload.id);
      localStorage.setItem('currentLanguageIcon', payload.icon);
      state.langIcon = payload.icon || 'flag-icon-us'
      state.langLangauge = payload.id || 'EN'
      // window.location.reload();
    },
    change(state){
      state.isActive = !state.isActive
    }
  },
  actions: {
    setLang ({ commit }, payload) {
      commit('changeLang', payload);
      
    }
  },
  modules: {
    layout,
    menu,
    statistic
    // report
  }
});

